<ng-template #content let-modal>
  <div class="modal-header">
    <button class="close" aria-label="Close" (click)="cancel()">
      <bfd-icon [img]="'close-blue'" [size]="'large'"></bfd-icon>
    </button>
  </div>
  <div class="modal-body">
    <bfd-icon
      [img]="'pict-blocked'"
      [typeIcon]="'pictograma'"
      [size]="'small'"
    ></bfd-icon>
    <bfd-divider [padding]="'small'"></bfd-divider>
    <h1>{{ title }}</h1>
    <bfd-divider [padding]="'small'"></bfd-divider>
    <p>
      {{ message }}
    </p>
  </div>
  <div class="modal-footer">
    <bfd-button
        [text]="'Cancelar'"
        [loading]="false"
        [disabled]="false"
        [type]="'secondary-large'"
        (buttonClick)="cancel()"
      ></bfd-button>
      <bfd-button
        [text]="'Tentar novamente'"
        [loading]="false"
        [disabled]="false"
        [type]="'primary-large'"
        (buttonClick)="confirm()"
      ></bfd-button>
  </div>
</ng-template>
